import { Button } from "@/components/ui/button";
import { rangeLabel } from "@/lib/paging";

/** Previous / Next + a truthful range label for a bounded, paged list. `testId` prefixes the control ids. */
export function PagedFooter({ page, onPrev, onNext, busy = false, testId = "paged" }) {
  if (!page) return null;
  const hasPrev = page.offset > 0;
  const hasNext = !!page.has_more;
  return (
    <div className="flex items-center justify-between gap-2 px-3 py-2 border-t text-xs text-muted-foreground scroll-mb-20" data-testid={`${testId}-footer`}>
      <span data-testid={`${testId}-range`}>{rangeLabel(page)}</span>
      <div className="flex gap-2">
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" disabled={!hasPrev || busy} onClick={onPrev} data-testid={`${testId}-prev`}>Previous</Button>
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" disabled={!hasNext || busy} onClick={onNext} data-testid={`${testId}-next`}>Next</Button>
      </div>
    </div>
  );
}

/** From / To (inclusive) IST dates + an optional search box + Clear. All values are plain strings; changing any of them is the caller's cue to reset to page 1. */
export function DateRangeBar({ from, to, q, onChange, onClear, testId = "range", showSearch = true, hint = null }) {
  const active = !!(from || to || q);
  return (
    <div className="flex flex-wrap items-end gap-2 p-3 border-b" data-testid={`${testId}-bar`}>
      <label className="text-[10px] uppercase text-muted-foreground space-y-1 block">
        <span>From (IST)</span>
        <input type="date" value={from || ""} max={to || undefined} onChange={(e) => onChange({ from: e.target.value })}
          className="block h-8 rounded-md border bg-background px-2 text-xs text-foreground normal-case" data-testid={`${testId}-from`} />
      </label>
      <label className="text-[10px] uppercase text-muted-foreground space-y-1 block">
        <span>To (IST, inclusive)</span>
        <input type="date" value={to || ""} min={from || undefined} onChange={(e) => onChange({ to: e.target.value })}
          className="block h-8 rounded-md border bg-background px-2 text-xs text-foreground normal-case" data-testid={`${testId}-to`} />
      </label>
      {showSearch && (
        <label className="text-[10px] uppercase text-muted-foreground space-y-1 block">
          <span>Search</span>
          <input type="search" value={q || ""} placeholder="Name, phone or email" onChange={(e) => onChange({ q: e.target.value })}
            className="block h-8 w-48 rounded-md border bg-background px-2 text-xs text-foreground normal-case" data-testid={`${testId}-q`} />
        </label>
      )}
      {active && <Button type="button" size="sm" variant="ghost" className="h-8 text-xs" onClick={onClear} data-testid={`${testId}-clear`}>Clear filters</Button>}
      {hint && <p className="basis-full text-[11px] text-muted-foreground" data-testid={`${testId}-hint`}>{hint}</p>}
    </div>
  );
}
